<div class="progress-bar">
  <div class="progress progress-moved">
    <div [style.width.%]="value" class="progress-bar"></div>
  </div>
</div>
